import { faCircleCheck as fasCircleCheck } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { BasicSuccessPage } from "@/component/assets/AbstractLeadForm/Steps/BasicSuccessPage";

export class SuccessPage extends BasicSuccessPage {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Body className="d-flex flex-column justify-content-center rounded text-white">
					<div className="d-flex px-3 py-2 border-bottom">
						<div className="text-center my-auto ml-auto">
							<FontAwesomeIcon icon={fasCircleCheck} className="text-gold" size="4x" />
						</div>
						<div className="text-uppercase font-weight-light h3 my-auto mr-auto ml-3">
							Elküldtük neked a kalkulációd eredményeit
						</div>
					</div>
					<div className="mt-2 text-white text-align-center text-center">
						Ha addig is további kérdésed lenne, írj nekünk <br /> a{" "}
						<a href="mailto:bankmonitor@bankmonitor.hu">bankmonitor@bankmonitor.hu</a> címre.
					</div>
				</Card.Body>
				{this.renderSubscribe()}
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.SuccessPage`;
	}
}
